import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { ProvinciasDef } from "./ProvinciasDef";


export class PaisesProvincias extends Entity<ProvinciasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ProvinciasDef(), parentKeys);
        this.Form = import('./PaisesProvinciasForm').then((module) => module.PaisesProvinciasForm);
        this.Title = "Provincias";
        this.Icon = IconBuildingCommunity;
        this.HelpText = "* Seleccione las provincias"
    }
}